import React, {useEffect} from 'react'
import { assetsBaseUrl } from "../../services/calculationsApi";
import {currencyToNumber, numberToCurrency} from "../../services/helpers";
import {gtm} from '../../services/gtm'
import {useIntl} from "react-intl";

function errorInfo(error, value) {
    // console.log(validationRules[error.type], error.ref.value)
    switch (error.type) {
        case "required":
            return error;
        case "min":
            return value && value.length > 1;

        case "max":
            return error;
        default:
            return error;
    }
}

function Input({
    name,
    label,
    inputType,
    icon,
    iconText,
    onIconClick,
    className,
    placeholder,
    register,
    validationRules,
    type,
    error,
    isDisabled,
    value,
    errorTitle,
    valueType,
}) {
    const intl = useIntl();
    let viewValue = value;
    const highAgeCondition =
        valueType === "age" &&
        value &&
        value.length > 1 &&
        value > 56 &&
        value < 67;

    useEffect(() => {
        if (!highAgeCondition) return;
        const tagManagerArgs = {
            gtmId: 'GTM-T78CX5',
            dataLayer: {
                event: 'gtm.calculators',
                eventCategory: "Calculator",
                eventAction: 'Bruto Jaarinkomen',
                eventLabel: 'pensioeninkomen en aow gevraagd'
            }
        };
        gtm(tagManagerArgs);

    }, [highAgeCondition])
    if (!register) {
        return null;
    }

    let errorCondition;

    if (error) {
        errorCondition = errorInfo(error, value);
    }

    function getType(type) {
        if (type === "currency") {
            return "text";
        }
        return type ? type : "text";
    }

    function setType($event, type, action) {
        if (type === "currency") {
            // if it is a int (even 0) on blur we return it and Math.round
            // if it is not an int we return null
            // always round up
            if (action === "blur") {
                //viewValue = ($event.target.value > 0) ? Math.ceil($event.target.value) : $event.target.value
                viewValue = $event.target.value
            } else {
                viewValue = currencyToNumber($event.target.value);
            }

            $event.target.type = action === "focus" ? "number" : "text";
            $event.target.value = action === "blur" ? (viewValue) ? numberToCurrency(viewValue) : null : viewValue;
        }
    }

    return (
        <div
            className={`ct-input_wrapper
            ${inputType === "secondary" ? "ct-input_wrapper-secondary" : null}
            ${valueType === "-" ? "minus-currency" : null}`}
        >
            {label && <div className="ct-input-label">{label}</div>}

            <div
                className={`ct-input ${className} ${
                    (errorCondition || highAgeCondition || error) && "ct-input-error"
                    //(errorCondition) && "ct-input-error"
                } ${(iconText) && "ct-input--short-border"}`}
            >
                <input
                    autoComplete="off"
                    onFocus={e => setType(e,type, 'focus')}
                    onBlur={e => setType(e, type, 'blur')}
                    onWheel={e => e.target.blur()}
                    type={getType(type)}
                    name={name}
                    disabled={isDisabled}
                    placeholder={placeholder}
                    ref={register(validationRules)}
                />

                {icon && (
                    <div className={`ct-input-icon ${(iconText) && 'ct-input-icon--text'}`} onClick={onIconClick}>
                        <img src={assetsBaseUrl + icon} alt="" /> <div dangerouslySetInnerHTML={{__html: iconText}} />
                    </div>
                )}

                {inputType === "secondary" && (
                    <div className="ct-input-currency">
                        {valueType === "-" ? valueType : null} €
                    </div>
                )}
            </div>

            {errorCondition && (
                <div className="ct-input_error-msg">
                    {error.type === "required" &&
                    intl.formatMessage(
                    {
                      id: "general.validations.required",
                      defaultMessage: "Je bent je {errorTitle} vergeten in te vullen.",
                    },
                    {
                      errorTitle,
                    }
                    )}


                    {error.type === "min" && valueType === "age" && value?.length > 1 &&
                      intl.formatMessage({ id: "general.validations.minAge", defaultMessage: "Je kunt deze berekening alleen gebruiken als je 18 jaar of ouder bent." })
                    }

                    {/*error.type === "max" && (
                        <div>
                            Op dit moment werkt onze rekentool niet bij een
                            leeftijd boven de 67 jaar. Onze excuses voor het
                            ongemak. Op één van onze{" "}
                            <a href="https://www.hypotheker.nl/vestigingen/">
                                vestigingen
                            </a>{" "}
                            vertellen we je in een (vrijblijvend) gesprek graag
                            meer over de mogelijkheden.
                        </div>
                    )*/}
                </div>
            )}

            {highAgeCondition && (
                <div className="ct-input_error-msg">
                  {intl.formatMessage({ id: "general.validations.highAge", defaultMessage: "Bij een leeftijd boven de 56 jaar houden hypotheekverstrekkers rekening met het pensioeninkomen. Vul hieronder de hoogte van je toekomstige AOW en pensioeninkomen in om uit te rekenen wat de hoogte van je maximale hypotheek is." })}
                </div>
            )}
        </div>
    );
}

export default Input;
